<div class="marker-popup">
  <div class="marker-detail-wraper">
    <table class="marker-detail-table">
      <caption>
        Asset marker-popup content alignment.
      </caption>
      <tr>
        <th class="marker-detail-table-heading">Asset Name</th>
        <td class="marker-detail-table-text">{{ marker?.name ?? '' }}</td>
      </tr>
      <tr>
        <th class="marker-detail-table-heading">Last Active</th>
        <td class="marker-detail-table-text">
          {{ getLatestCheckInHistory() | date: 'short' }}
        </td>
      </tr>
      <tr>
        <th class="marker-detail-table-heading">Dormant Duration</th>
        <td class="marker-detail-table-text">
          {{ getDormatoryDuration() ?? '' }} Days
        </td>
      </tr>
      <tr>
        <th class="marker-detail-table-heading">Asset Type</th>
        <td class="marker-detail-table-text">
          {{ marker?.cable?.assetType ?? '' }}
        </td>
      </tr>
    </table>
    <div>
      <div class="marker-notes-heading">Notes</div>
      <textarea disabled name="notes" id="notes" cols="30" rows="3">{{
        marker?.documents[0]?.notes
      }}</textarea>
    </div>
  </div>
  <div class="btn-asset-edit-wraper">
    <button class="asset-edit-btn" color="accent" (click)="edit()">
      <mat-icon svgIcon="edit"></mat-icon>
      <span class="asset-edit-btn-text">Edit</span>
    </button>
  </div>
</div>
